import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { levelsQuery } from '~/util/queries/public/levels';
import { useAlphabetStore } from '~/util/stores/alphabet';
import { AlphabetHome } from './-Home';
import { AlphabetRound } from './-Round';
import { seo } from '~/util';
import { PlacedLevel } from '~/util/types/levels';

export const Route = createFileRoute('/games/alphabet')({
    loader: async ({ context: { queryClient } }) => {
        return (await queryClient.fetchQuery(
            levelsQuery({
                list: 'classic',
                exclude_pending: true,
                exclude_removed: true,
            }),
        )) as PlacedLevel[];
    },
    head: () => ({
        meta: seo({
            title: 'Extreme Demon Alphabet',
        }),
    }),
    component: AlphabetLayout,
});

function AlphabetLayout() {
    const {
        data: {
            currentGameState: { level },
        },
        migrateFromOldData,
    } = useAlphabetStore();

    // Migrate old localStorage data to new format on mount
    useEffect(() => {
        migrateFromOldData();
    }, [migrateFromOldData]);

    return level == undefined ? <AlphabetHome /> : <AlphabetRound />;
}
